import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { productsApi } from '@/lib/api-client';
import { CRV_FEE_OPTIONS } from '@/lib/constants';

/**
 * The tenant's configurable CRV fee options (cents). Configured once per
 * client in the products service; the product + department forms use it in
 * place of the hardcoded defaults, so no code change is needed per client.
 * Falls back to the built-in CRV_FEE_OPTIONS while loading or if unset.
 */
export function useCrvOptions() {
  const query = useQuery<{ data: number[] }>({
    queryKey: ['crv-options'],
    queryFn: () => productsApi.get('/tenant-settings/crv-options'),
    staleTime: 5 * 60_000,
  });
  const options = query.data?.data?.length ? query.data.data : [...CRV_FEE_OPTIONS];
  return { ...query, options };
}

export function useUpdateCrvOptions() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (options: number[]) => productsApi.put<{ data: number[] }>('/tenant-settings/crv-options', { options }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['crv-options'] }),
  });
}
